import classNames from "classnames";
import classes from "./SaleEndIndicator.module.less";
import dayjs from "dayjs";
import LabelBox from "~/SalesCampaign/components/LabelBox/LabelBox";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
  endDate?: Date;
}

export const SaleEndIndicator = (props: Props) => {
  const { t } = useTranslation();
  const end = dayjs(props.endDate);

  const today = dayjs();

  const days = end.diff(today, "day");

  // let label;
  // if (!props.endDate) {
  //   label = t("feature.salesCampaign.indicator.saleEnd.noEnd");
  // } else if (days >= 1) {
  //   label = t("feature.salesCampaign.indicator.saleEnd.days", { count: days });
  // } else {
  //   label = t("feature.salesCampaign.indicator.saleEnd.today");
  // }

  const label = t("feature.salesCampaign.indicator.saleEnd.noEnd");

  return (
    <LabelBox variant={"inactive"} className={classNames(classes.root, props.className)}>
      {label}
    </LabelBox>
  );
};
